import React, { useContext, useMemo } from 'react';
import { ContextMenu } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const ActionsRenderer = ({ inviteAdmin, rowData, columnData: { handleDelete, handleEdit } }) => {
  const { t } = useContext(ConfigContext);
  const options = useMemo(
    () => [
      { label: t('invite'), disabled: rowData.id <= 0, onClick: () => inviteAdmin(rowData.id) },
      { label: rowData?.id ? t('edit') : t('add'), onClick: () => handleEdit(rowData) },
      {
        label: t('delete'),
        onClick: () => handleDelete(rowData.id),
        visible: !!rowData?.id,
        confirm: true,
        confirmBody: t('areYouSureYouWantToDelete'),
        confirmText: 'delete',
        confirmPortal: true
      }
    ],
    [handleDelete, handleEdit, inviteAdmin, rowData, t]
  );

  return <ContextMenu options={options} usePortal />;
};

export default ActionsRenderer;
